function calendarBuild(){
    var calendarData = calendarObjectData.calendarData;
    var currentDate = new Date();
    var currentYear = currentDate.getFullYear();
    var currentMonth = currentDate.getMonth();
  
    var prevButton = document.querySelector(".prev-month");
    var nextButton = document.querySelector(".next-month");
    var todayButton = document.querySelector(".today-button");
    var monthTitle = document.querySelector(".calendar-header h2");
    var calendarTable = document.querySelector(".calendar-table tbody");

      // Find the earliest month with dates
      while (true) {
        var firstDay = new Date(currentYear, currentMonth, 1);
        var lastDay = new Date(currentYear, currentMonth + 1, 0);
        var currentDate = new Date(currentYear, currentMonth, 1);
    
        while (currentDate <= lastDay) {
          if (
            currentDate >= new Date(calendarData.earliestBookableDate) &&
            currentDate <= new Date(calendarData.latestBookableDate) &&
            currentDate >= firstDay &&
            currentDate <= lastDay
          ) {
            break;
          }
          currentDate.setDate(currentDate.getDate() + 1);
        }
    
        if (currentDate <= lastDay) {
          break;
        }
    
        currentMonth++;
        if (currentMonth > 11) {
          currentMonth = 0;
          currentYear++;
        }
      }
    
      
      function generateCalendar() {
        var monthTitle = document.querySelector(".calendar-header h2");
        var calendarTable = document.querySelector(".calendar-table tbody");
        var prevButton = document.querySelector(".prev-month");
        var nextButton = document.querySelector(".next-month");
        
        // Get the first day of the current month
        var currentMonthStart = new Date(currentYear, currentMonth, 1);
      
        // Clear the calendar table
        calendarTable.innerHTML = "";
      
        // Calculate the last day of the current month
        var currentMonthEnd = new Date(currentYear, currentMonth + 1, 0);
      
        // Create a variable to store the current day being added
        var currentDate = new Date(currentMonthStart);
      
        // Determine whether the previous and next buttons should be disabled
        var isPrevDisabled = currentDate <= new Date(calendarData.earliestBookableDate);
        var isNextDisabled = currentDate > new Date(calendarData.latestBookableDate);
      
        // Calculate the day offset based on the day of the week (0 - Sunday, 1 - Monday, ...)
        var firstDayOfWeek = currentMonthStart.getDay();
      
        // Calculate the number of days to offset for the first day
        var daysToOffset = (firstDayOfWeek - 1 + 7) % 7;
      
        // Subtract the daysToOffset to position the first day correctly
        currentDate.setDate(currentDate.getDate() - daysToOffset);
      
        // Loop through the weeks
        for (var week = 0; week < 6; week++) {
          var row = document.createElement("tr");
      
          // Loop through the days of the week
          for (var dayOfWeek = 0; dayOfWeek < 7; dayOfWeek++) {
            var cell = document.createElement("td");
      
            // Check if the current date is within the range
            if (
              currentDate >= new Date(calendarData.earliestBookableDate) &&
              currentDate <= new Date(calendarData.latestBookableDate) &&
              currentDate >= currentMonthStart &&
              currentDate <= currentMonthEnd
            ) {
              var dayOfMonth = currentDate.getDate();
              var openingHours = getOpeningHours(currentDate);
              var dayName = getDayName(currentDate);
              if(openingHours === 'Closed'){
              cell.classList.add("closed");
              var appendHtml = openingHours
                ? '<span class="date">' + dayOfMonth + '</span> ' +
                    '<div class="opening">' + 
                    '<span class="day">' + getFullDayName(dayName) + '</span>' +
                    '<span class="opening">' + openingHours + '</span>' +
                    '</div>'
                : '<span class="day">' + dayOfMonth + '</span>';

                cell.innerHTML = appendHtml;
              } else {
                cell.classList.add("open");
                // Get the local time zone offset
                var timeZoneOffset = currentDate.getTimezoneOffset();

                // Adjust the date according to the local time zone
                var adjustedDate = new Date(currentDate.getTime() - timeZoneOffset * 60 * 1000);

                // Format the adjusted date as yyyy-mm-dd
                var formattedDate = adjustedDate.toISOString().split('T')[0];
                    
                    // Create the dynamic booking link with the formatted date
                    var bookLink = "/book-tickets/#/date/" + formattedDate + "/time";
  
                var appendHtml = openingHours
                  ? '<span class="date">' + dayOfMonth + '</span> ' +
                      '<div class="opening">' + 
                      '<span class="day">' + getFullDayName(dayName) + '</span>' +
                      '<span class="opening">' + openingHours + '</span>' +
                      '</div>' +
                      '<a class="button" href="' + bookLink +'">Book Now</a>'
                  : '<span class="day">' + dayOfMonth + '</span>';
  
                  cell.innerHTML = appendHtml;
              }
              
            } else {
              // Add an empty cell for days outside the range
              cell.textContent = "";
              cell.classList.add("cell-empty"); 
            }
      
            row.appendChild(cell);
            currentDate.setDate(currentDate.getDate() + 1);
          }
      
          calendarTable.appendChild(row);
        }
      
        // Update the month title
        monthTitle.textContent = new Intl.DateTimeFormat("en-US", { year: "numeric", month: "long" }).format(currentMonthStart);
      
        // Update the disabled state of the previous and next buttons
        prevButton.disabled = isPrevDisabled;
        nextButton.disabled = isNextDisabled;
      }
      
      function getOpeningHours(date) {
      
        var override = calendarData.overrideSpecificDates.find(function (overrideDate) {
          return overrideDate.date === formatDate(date);
        });
      
      
        if (override) {
          return override.opening_hours;
        }
      
        var dayName = getDayName(date);
      
        return calendarData.globalOpeningHours[dayName];
      }


      function formatDate(date) {
        var month = date.getMonth() + 1;
        var day = date.getDate();
        var year = date.getFullYear();
        return `${formatNumber(month)}/${formatNumber(day)}/${year}`;
      }
      
      function formatNumber(number) {
        return number < 10 ? "0" + number : number;
      }
      
  
    function getDayName(date) {
      var days = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
      return days[date.getDay()];
    }

    function getFullDayName(dayName) {
        var fullDayNames = {
          "mon": "Monday",
          "tue": "Tuesday",
          "wed": "Wednesday",
          "thu": "Thursday",
          "fri": "Friday",
          "sat": "Saturday",
          "sun": "Sunday"
        };
      
        return fullDayNames[dayName] || dayName;
      }
  
    function updateCalendar(direction) {
        var loopGuard = 0; // Set a limit for loop iterations
      
        while (loopGuard < 13) { // Maximum of 12 months to avoid infinite loop
          if (direction === "prev") {
            currentMonth--;
            if (currentMonth < 0) {
              currentMonth = 11;
              currentYear--;
            }
          } else if (direction === "next") {
            currentMonth++;
            if (currentMonth > 11) {
              currentMonth = 0;
              currentYear++;
            }
          }
          generateCalendar();
      
          // Check if there are dates for the current month
          var firstDay = new Date(currentYear, currentMonth, 1);
          var lastDay = new Date(currentYear, currentMonth + 1, 0);
          var currentDate = new Date(currentYear, currentMonth, 1);
          var hasDates = false;
      
          while (currentDate <= lastDay) {
            if (
              currentDate >= new Date(calendarData.earliestBookableDate) &&
              currentDate <= new Date(calendarData.latestBookableDate) &&
              currentDate >= firstDay &&
              currentDate <= lastDay
            ) {
              hasDates = true;
              break;
            }
            currentDate.setDate(currentDate.getDate() + 1);
          }
      
          if (hasDates) {
            break;
          }
      
          loopGuard++;
        }
      }

    generateCalendar();
  
    prevButton.addEventListener("click", function() {
      updateCalendar("prev");
    });
  
    nextButton.addEventListener("click", function() {
      updateCalendar("next");
    });
  

  }

  document.addEventListener('DOMContentLoaded', () => {


		if (document.querySelector('.opening-hours-calendar')){
			calendarBuild();
		}
	});

